/**
 * ResponsiveImage Component Types
 *
 * Defines TypeScript interfaces and types for the ResponsiveImage component
 * supporting both web (Next.js) and mobile (Expo) implementations.
 */
/**
 * Aspect ratio mapping for consistent calculations
 */
export const ASPECT_RATIO_MAP = {
    square: 1,
    '16:9': 16 / 9,
    '4:3': 4 / 3,
    '3:2': 3 / 2,
};
/**
 * Calculate padding-bottom percentage for aspect ratio containers
 */
export function calculateAspectRatioPadding(aspectRatio) {
    if (typeof aspectRatio === 'number') {
        if (aspectRatio <= 0) {
            throw new Error('AspectRatio must be greater than 0');
        }
        return (1 / aspectRatio) * 100;
    }
    const ratio = ASPECT_RATIO_MAP[aspectRatio];
    return (1 / ratio) * 100;
}
/**
 * Get CSS aspect-ratio value for modern browsers
 */
export function getAspectRatioValue(aspectRatio) {
    if (typeof aspectRatio === 'number') {
        if (aspectRatio <= 0) {
            throw new Error('AspectRatio must be greater than 0');
        }
        return `${aspectRatio}`;
    }
    const ratio = ASPECT_RATIO_MAP[aspectRatio];
    return `${ratio}`;
}
